import { BCMSCurrency, BCMSDate, BCMSDefaultModel, BCMSRecord, useGlobalController, useModel, useParams, Workflow } from "@bcm-dev/bcms-vite";
import AddReminderPage from "compid/pages/AddReminderPage";
import ReminderConfirmationPage from "compid/pages/ReminderConfirmationPage";
import { Bill, Biller, Reminder } from "model";
import React from "react";

// Steps of the workflow
const steps = {
    "/addReminder" : <AddReminderPage/>,
    "/addReminderConfirmation" : <ReminderConfirmationPage/>
};

/**
 * @function ReminderWorkflow
 * @returns {React.Component}
 * @description The main component for the reminder workflow
 */
export default function ReminderWorkflow(props) {
    // Initalize a global controller instance
    const controller = useGlobalController();
    // Grab the billerID from the parameters
    const { billerID } = useParams();
    // Access model.
    const model = useModel();
    // Get the default value for the workflow
    const value = getDefault(controller, billerID, model); 
    const constructor = value => {
        const defaultValues = getDefault(controller, billerID, model);
        const mergedReminder = { ...defaultValues.reminder.record, ...value.reminder ?? {} };

        const reminder = Reminder.init(mergedReminder);

        if(value.setDateToFirstOfMonth !== undefined && value.setDateToFirstOfMonth === true) {
            const date = BCMSDate.init().setToFirst().offset([ 0, 1, 0]);

            reminder.typicalDueDate = date;
            reminder.dueDate = date;
        }
        
        reminder.email = model ? model.emails[0].emailName : "e@example.com";
        console.log(reminder);

        return { ...defaultValues, ...value, reminder }
    }

    return <Workflow value={ value } steps={ Object.values(steps) } constructor={ constructor } />
}

/**
 * @function getWorkflowSteps
 * @returns {OBJECT}
 * @description Hook to get the steps of the reminder workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {BCMSGlobalController} controller - Global controller instance
 * @param {STRING} billIDs - The bill ids passed through the parameter
 * @returns {OBJECT}
 * @note The billIDs parameter expects ids formatted as "1,2,3" since thats how they are being passed from the useParams
 * @description Function to create the default value of the reminder workflow.
 */
export const getDefault = (controller, billerID, model) => {
    BCMSRecord.globalControllerFor([ Biller, Bill, Reminder ], controller);
    const biller = billerID === undefined ? Biller.firstInstanceOf() : Biller.initByID(billerID);
    var reminder = BCMSDefaultModel.reminder();
    reminder.id = Reminder.nextID();
    reminder.email = model ? model.emails[0].emailName : "e@example.com";
    reminder.biller = biller;
    reminder.amount = BCMSCurrency.init(0).format();

    return { 
        reminder: reminder,
        userDidSetDueDate: false,
        userDidSetBillReceivedFrequency: false,
        userDidSetDaysToRemindMeInAdvanced: false 
    };
};